import { createPhantomTypeSchema, MaybeT, t } from '../../../../universal';
import { React } from '../../../lib';
import { ColorPicker } from '../color';
import { readDynamic } from './types';
export const FormTypeColourPicker = (settings) => ({
    ...settings,
    valueDefaults: {
        def: () => null,
        fixer: x => x?.trim().toLowerCase() || null,
        validators: [],
    },
    height: 36,
    typeMap: {
        schemaPublic: createPhantomTypeSchema(MaybeT(t.String())),
        schemaRaw: createPhantomTypeSchema(MaybeT(t.String())),
        toPublic: (x) => x,
        toInternal: (x) => x,
    },
    llmInfo: formState => ({
        stringifiedType: 'text',
        description: readDynamic(settings.doc, formState) ?? readDynamic(settings.lbl, formState),
        reversal: x => String(x ?? '') || null,
    }),
    jsx: props => (React.createElement(ColorPicker, { value: props.value ?? null, onUpdate: props.onUpdate, className: props.className ?? undefined, title: props.title ?? undefined, readOnly: props.readOnly || props.disabled, onFocus: props.onFocus, onBlur: props.onBlur, colors: settings.colours })),
});
//# sourceMappingURL=fields-colour.js.map